import { mapKeys, pickBy } from 'lodash-es'
import { parseISO, isValid, format } from 'date-fns'
import { METADATA_FILTER_DATE_FORMAT } from './filter.const'

import { deepToRaw } from '@lib/util/reactive'

export function normalizeFilterParams(params: Record<string, any>) {
  let normalizedParams = deepToRaw(params)

  // remove all 'system:xxxx' filterParams
  normalizedParams = pickBy(normalizedParams, (value, key) => {
    return !key.includes('system:')
  })

  normalizedParams = mapKeys(normalizedParams, (_, key) => {
    const isDateRange =
      Array.isArray(normalizedParams[key]) &&
      normalizedParams[key].length === 2 &&
      normalizedParams[key].every((date: string) => {
        const parsedDate = parseISO(date)
        return (
          typeof date === 'string' && isValid(parsedDate) && format(parsedDate, METADATA_FILTER_DATE_FORMAT) === date
        )
      })
    return `metadata__${key}${isDateRange ? '__range' : ''}`
  })

  return normalizedParams
}

export function normalizeNetworkFilterParams(params?: Record<string, any> | null) {
  if (!params) return {}

  return Object.entries(params).reduce(
    (acc, [key, value]) => {
      acc[key] = key.endsWith('__range') && Array.isArray(value) ? value.join(',') : value

      return acc
    },
    {} as Record<string, any>,
  )
}
